import script from "./srmLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./srmLogin.vue?vue&type=script&setup=true&lang=js"

import "./srmLogin.vue?vue&type=style&index=0&id=1f8c5347&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8c5347"]])

export default __exports__